<template>
  <section class="modal">
    <div class="message">
      <div class="message__text">Are you over 18?</div>
      <div class="message-answer">
          <a class="message-answer__item" @click.prevent="next">Yes</a>
          <a class="message-answer__item" href="https://google.com/">No</a>
      </div>
    </div>
  </section>
</template>

<script>
    export default {
        methods:{
            next(){
                this.$emit('next')
            }
        }
    }
</script>

<style lang="scss" scoped>
.modal {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.message {
  width: 290px;
  background-color: rgba(255, 255, 255, 0.95);
  min-height: 200px;
  border-radius: 15px;
  text-align: center;
  padding: 15px;
  display: flex;
  align-self: center;
  justify-content: center;
  flex-direction: column;
  &__text {
      margin-bottom: 20px;
    color: #000;
    font-weight: 500;
    font-size: 20px;
  }
  &-answer{
      display: flex;
      justify-content: space-between;
      width: 100px;
      margin: 0 auto;
      &__item{
          font-size: 25px;
          color: #404eff;
          text-decoration: none;
          cursor: pointer;
      }
  }
}
</style>